import { CardSchema } from "./card";
import { ProductCodeSchema } from "./product";
import { FeaturesSummary } from "./features";
import { BillingIntervalSchema } from "./price";
import { z } from "zod";
export const StripeSubscriptionStatusSchema = z.enum([
  "trialing",
  "active",
  "past_due",
  "canceled",
  "unpaid",
  "incomplete_expired",
  "incomplete",
  "unknown",
]);

export const InternalStatusSchema = z.enum(["active", "suspended", "gracePeriod", "cancelled", "downgraded_to_free"]);

export const BillingTypeSchema = z.enum(["Auto", "Invoice"]);

export type StripeSubscriptionStatus = z.infer<typeof StripeSubscriptionStatusSchema>;
export type InternalStatus = z.infer<typeof InternalStatusSchema>;
export type BillingType = z.infer<typeof BillingTypeSchema>;

export const StripeSubscriptionStatus = StripeSubscriptionStatusSchema.enum;
export const InternalStatus = InternalStatusSchema.enum;
export const BillingType = BillingTypeSchema.enum;

export const Subscription = z.object({
  stripeSubscriptionId: z.string().nullish(),
  stripeCustomerId: z.string().nullish(),

  status: InternalStatusSchema.optional(),
  subscriptionStatus: StripeSubscriptionStatusSchema.optional(), // the stripe API official status
  internalStatus: InternalStatusSchema.optional(), // TODO: delete when create/get workspace will stop using it in the former API

  product: ProductCodeSchema,
  featuresSummary: FeaturesSummary.optional(),
  stripeProductDescription: z.string().optional(),
  stripeProductFeatures: z.array(z.string()).optional(),
  stripeProductAdditionalFeatures: z.array(z.string()).optional(),
  stripeSubscriptionMainItemId: z.string().optional(),
  planPriceId: z.string(),
  planInterval: BillingIntervalSchema,
  isPricePerCreator: z.boolean().optional(),
  legacyVersion: z.string().optional(),

  seats: z.number(),
  seatLimit: z.number(),

  currentPeriodStart: z.string().optional(),
  currentPeriodEnd: z.string().optional(),
  subscriptionStatusUpdatedAt: z.string().optional(),
  cancelAt: z.string().nullish(),

  card: CardSchema.optional(),

  // New
  amount: z.number().nullish(),
  isTrial: z.boolean().optional(),
  billingType: BillingTypeSchema.optional(),
  daysUntilDue: z.number().optional(),
});

export type Subscription = z.infer<typeof Subscription>;
